"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BasePlugin = void 0;
class BasePlugin {
    constructor() {
        this.defaultConfig = {};
    }
    applyAttributes(attributes) {
        return Object.entries(attributes)
            .map(([key, value]) => `${key}="${value}"`)
            .join(' ');
    }
    resolveClassNames({ visibleOn, classNames = '' }, contextConfig) {
        const contextBreakpoint = contextConfig?.breakpoint;
        const cssString = ['A', 'B', 'C', 'D']
            .reduce((css, breakpoint) => !((visibleOn ?? []).includes(breakpoint) || // explicit rule
            // implicit rule
            (contextBreakpoint && contextBreakpoint === breakpoint))
            ? `${css} not-size-${breakpoint.toLowerCase()}`
            : css, '')
            .trimStart();
        return `${cssString}${cssString && classNames ? ' ' : ''}${classNames ?? ''}`;
    }
    render(config, contextConfig) {
        const markup = this.generateMarkup(config, contextConfig);
        const attributes = this.applyAttributes({
            class: this.resolveClassNames(config, contextConfig),
            ...config.attributes,
        });
        return markup.replace(/(<[^>]+)>/, `$1 ${attributes}>`);
    }
}
exports.BasePlugin = BasePlugin;
//# sourceMappingURL=index.js.map